import React from 'react';
import { Divider, Popconfirm } from 'antd';

export default self => [
  {
    title: '敏感词',
    dataIndex: 'word',
    key: 'word',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    width: 190,
  },
  {
    title: '最后更新时间',
    dataIndex: 'update_time',
    key: 'update_time',
    width: 190,
  },
  {
    title: '最近更新人',
    dataIndex: 'operator_name',
    key: 'operator_name',
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 160,
    render: (t, item) => (
      <div>
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑敏感词',
              item,
              visible: true,
            });
          }}
        >
          编辑
        </a>
        <Divider type="vertical" />
        <Popconfirm
          title="确认删除？"
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() => self.deleteItem(item.id)}
        >
          <a>删除</a>
        </Popconfirm>
      </div>
    ),
  },
];
